import { render } from "./MenuItem.vue?vue&type=template&id=25922a06&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=25922a06&scoped=true&lang=css"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25922a06"]])

export default __exports__